import { PageSections, PageSectionsContentSectionContentBlocks, PageSectionsHorizontalCtaBanner } from '@/tina/__generated__/types';
import { ArticleQuery } from '../app/pageClient';
import { ArticleList } from './ArticleLists/ArticleList';
import { BodyArticle } from './BodyText';
import { CalloutWithImage } from './CalloutWithImage';
import { ContactSection } from './ContactBlock';
import { ContentBlocks } from './ContentBlocks';
import { HorizontalCtaBanner } from './HorizontalCtaBanner';
import { PageSection } from './PageSection';
import { SectionHeading } from './SectionHeading';
import { ServiceLinks } from './ServiceLinks';
import { TextBanner } from './TextBanner';
import { LandingHero } from './LandingHero/LandingHero';
export type SectionsData = PageSections;
interface PageContentSectionsProps {
  data?: SectionsData[];
  articleQuery?: ArticleQuery;
  isClient?: boolean;
}
export function PageContentSections({
  data,
  articleQuery,
  isClient
}: PageContentSectionsProps) {
  return data?.map((section, i) => {
    const key = `${i}-${section.__typename}`;
    switch (section.__typename) {
      case 'PageSectionsContentSection':
        const {
          contentBlocks
        } = section;
        return <PageSection key={key}>
            <SectionHeading data={section} />
            <ContentBlocks data={contentBlocks as PageSectionsContentSectionContentBlocks[]} />
          </PageSection>;
      case 'PageSectionsHorizontalCtaBanner':
        return <HorizontalCtaBanner data={section as PageSectionsHorizontalCtaBanner} key={key} />;
      case 'PageSectionsTextBanner':
        return <TextBanner data={section} key={key} />;
      case 'PageSectionsCalloutCardWithImage':
        return <CalloutWithImage data={section} key={key} />;
      case 'PageSectionsServiceLinks':
        return <ServiceLinks data={section} key={key} />;
      case 'PageSectionsContactSection':
        return <ContactSection data={section} key={key} />;
      case 'PageSectionsArticleList':
        return <ArticleList key={key} data={section} articleQuery={articleQuery} isClient={isClient} />;
      case 'PageSectionsBody':
        return <BodyArticle content={section.body} key={key} />;
      case 'PageSectionsLandingHero':
        return <LandingHero data={section} key={key} />;
      default:
        return null;
    }
  });
}